export const FETCH_FEED_DAY_REQUEST = "stats/FETCH_FEED_DAY_REQUEST";
export const FETCH_FEED_DAY_SUCCESS = "stats/FETCH_FEED_DAY_SUCCESS";
export const FETCH_FEED_DAY_FAILURE = "stats/FETCH_FEED_DAY_FAILURE";

export const FETCH_EPISODE_DAY_REQUEST = "stats/FETCH_EPISODE_DAY_REQUEST";
export const FETCH_EPISODE_DAY_SUCCESS = "stats/FETCH_EPISODE_DAY_SUCCESS";
export const FETCH_EPISODE_DAY_FAILURE = "stats/FETCH_EPISODE_DAY_FAILURE";

export const FETCH_FEED_LISTENERS_REQUEST = "stats/FETCH_FEED_LISTENERS_REQUEST";
export const FETCH_FEED_LISTENERS_SUCCESS = "stats/FETCH_FEED_LISTENERS_SUCCESS";
export const FETCH_FEED_LISTENERS_FAILURE = "stats/FETCH_FEED_LISTENERS_FAILURE";

export const FETCH_EPISODE_LISTENERS_REQUEST = "stats/FETCH_EPISODE_LISTENERS_REQUEST";
export const FETCH_EPISODE_LISTENERS_SUCCESS = "stats/FETCH_EPISODE_LISTENERS_SUCCESS";
export const FETCH_EPISODE_LISTENERS_FAILURE = "stats/FETCH_EPISODE_LISTENERS_FAILURE";

export const FETCH_SNAPSHOT_REQUEST = "stats/FETCH_SNAPSHOT_REQUEST";
export const FETCH_SNAPSHOT_SUCCESS = "stats/FETCH_SNAPSHOT_SUCCESS";
export const FETCH_SNAPSHOT_FAILURE = "stats/FETCH_SNAPSHOT_FAILURE";
